export default interface LocationFilter {
	state: Array<string>;
	city: string;
	enabled: string;
	locationTypes: Array<number>;
}

export const LocationTypes = {
	VALUE_ATM: 1,
	VALUE_BRICK: 2,
	VALUE_BRICK_ATM: 3
};